export const UserRefFragment = /* GraphQL */ `
	fragment UserRefFragment on Role {
		_id
		first_name
		last_name
	}
`;
